import React from "react";

const shapes = Array.from({ length: 9 }, (_, i) => {
    const TL = { x: 280 + 40 * i, y: 250 + 55 * i };
    const TR = { x: TL.x + 800, y: TL.y };
    const BL = { x: TL.x - 260, y: TL.y + 500 };
    const BR = { x: TR.x - 260, y: TR.y + 500 };
    return { TL, TR, BR, BL };
});

function opacityFor(i) {
    const opacities = [1, 0.9, 0.78, 0.66, 0.54, 0.42, 0.31, 0.22, 0.14];
    return opacities[i] ?? 0.14;
}

export default function HeaderPattern({ className = "", style = {} }) {
    return (
        <svg
            className={className}
            style={style}
            viewBox="-110 -50 1600 1000"
            preserveAspectRatio="xMidYMax slice"
            aria-hidden="true"
            focusable="false"
        >
            {shapes.map((sh, i) => (
                <path
                    key={i}
                    d={`M ${sh.TL.x} ${sh.TL.y} L ${sh.TR.x} ${sh.TR.y} L ${sh.BR.x} ${sh.BR.y} L ${sh.BL.x} ${sh.BL.y} Z`}
                    fill="none"
                    stroke={`rgba(255,255,255,${opacityFor(i)})`}
                    strokeWidth="2"
                    vectorEffect="non-scaling-stroke"
                />
            ))}
        </svg>
    );
}
